<template>
  <div class="page has-sidebar has-sidebar-fluid has-sidebar-expand-xl">
    <!-- .page-inner -->
    <div class="page-inner page-inner-fill position-relative">
      <header class="page-navs shadow-sm">
        <!-- .input-group -->
        <div class="input-group has-clearable">
          <button type="button" class="close" aria-label="Close">
            <span aria-hidden="true">
              <em class="fa fa-times-circle"></em>
            </span>
          </button>
          <label class="input-group-prepend" for="searchClients">
            <span class="input-group-text">
              <span class="oi oi-magnifying-glass"></span>
            </span>
          </label>
          <input type="text" class="form-control" id="searchClients" @keyup="inputText"
                 data-filter=".board .list-group-item" placeholder="Find album">
        </div><!-- /.input-group -->
      </header>

      <div class="board p-0 perfect-scrollbar" id="container">
        <!-- .list-group -->
        <div class="list-group list-group-flush list-group-divider border-top" data-toggle="radiolist">
          <template v-for="(list, i) in album_gallery">
            <div class="list-group-item" :class="{ 'active' : i == 0}" data-toggle="sidebar" data-sidebar="show">
              <a @click="selectItem(list)" class="stretched-link"></a>
              <div class="list-group-item-figure">
                <div class="tile tile-circle" :class="list.bg_color">{{ list.initial }}</div>
              </div>
              <div class="list-group-item-body">
                <h4 class="list-group-item-title">{{ list.title }}</h4>
                <p class="list-group-item-text">{{ list.summary }}</p>
              </div>
            </div>
          </template>

          <div class="list-group-item" v-show="loading" id="loading" >
            <!-- .list-group-item-body -->
            <div class="list-group-item-body text-center py-4">
              <!-- .spinner -->
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div><!-- /.spinner -->
            </div><!-- /.list-group-item-body -->
          </div>
        </div>
      </div>
    </div>
    <div class="page-sidebar bg-light">
      <!-- .sidebar-header -->
      <header class="sidebar-header d-xl-none">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item active">
              <a href="#" onclick="Looper.toggleSidebar()"><em class="breadcrumb-icon fa fa-angle-left mr-2"></em>Back</a>
            </li>
          </ol>
        </nav>
      </header>
      <div class="sidebar-section sidebar-section-fill">
        <div class="section-block">
          <h1 class="page-title">
            <em class="fa fa-photo-video text-muted mr-2"></em> PICTURE GALLERY
          </h1>
        </div>
        <div class="row pswp-gallery">
          <!-- grid column -->
          <div class="col-xl-3 col-lg-4 col-sm-6" v-for="(item, i) in items">
            <div class="card card-figure">
              <!-- .card-figure -->
              <figure class="figure">
                <!-- .figure-img -->
                <div class="figure-img">
                  <img class="img-fluid" :src="urlFile+item.file_path+'/'+item.photo" alt="Card image cap">
                  <a :href="urlFile+item.file_path+'/'+item.photo" class="img-link" :data-size="item.resolution">
                  <span class="tile tile-circle bg-danger">
                    <span class="oi oi-eye"></span>
                  </span>
                    <span class="img-caption d-none">{{item.name}}</span></a>
                  <div class="figure-action">
                    <a href="#" class="btn btn-block btn-sm btn-primary">View Details</a>
                  </div>
                </div><!-- /.figure-img -->
                <!-- .figure-caption -->
                <figcaption class="figure-caption">
                  <ul class="list-inline text-muted mb-0">
                    <li class="list-inline-item">
                      <span class="oi oi-paperclip"></span> {{item.size_file}}MB </li>
                    <li class="list-inline-item float-right">
                      <span class="oi oi-calendar"></span>
                    </li>
                  </ul>
                </figcaption><!-- /.figure-caption -->
              </figure><!-- /.card-figure -->
            </div>
          </div>
        </div>
        <div class="row align-items-center">
          <pagination-info :per-page="perPage" :rows="totalPicture" :current-page="currentPage"></pagination-info>
          <div class="col-sm-12 col-md-7 d-flex justify-content-end">
            <div class="dataTables_paginate paging_simple_numbers">
              <b-pagination v-model="currentPage" :per-page="perPage" v-on:click="getListPicture"   :total-rows="totalPicture" ></b-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="gallery" class="pswp" tabindex="-1" role="dialog" aria-hidden="true">
      <!-- .pswp__bg -->
      <div class="pswp__bg"></div><!-- .pswp__scroll-wrap -->
      <div class="pswp__scroll-wrap">
        <!-- .pswp__container -->
        <div class="pswp__container">
          <div class="pswp__item"></div>
          <div class="pswp__item"></div>
          <div class="pswp__item"></div>
        </div><!-- /.pswp__container -->
        <!-- .pswp__ui pswp__ui--hidden -->
        <div class="pswp__ui pswp__ui--hidden">
          <!-- .pswp__top-bar -->
          <div class="pswp__top-bar">
            <div class="pswp__counter"></div><button class="pswp__button pswp__button--close" title="Close (Esc)"></button> <button class="pswp__button pswp__button--share" title="Share"></button> <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button> <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>
            <div class="pswp__preloader">
              <div class="pswp__preloader__icn">
                <div class="pswp__preloader__cut">
                  <div class="pswp__preloader__donut"></div>
                </div>
              </div>
            </div>
          </div><!-- /.pswp__top-bar -->
          <!-- .pswp__share-modal -->
          <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
            <div class="pswp__share-tooltip"></div>
          </div><!-- /.pswp__share-modal -->
          <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)"></button> <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)"></button>
          <div class="pswp__caption">
            <div class="pswp__caption__center"></div>
          </div>
        </div><!-- /.pswp__ui pswp__ui--hidden -->
      </div><!-- /.pswp__scroll-wrap -->
    </div>
  </div>
</template>

<script>
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";
import {BPagination} from "bootstrap-vue";
import PaginationInfo from "../../PaginationInfo";

export default {
  name: "PictureGallery",
  components:{
    PaginationInfo,
    BPagination
  },
  data(){
    return {
      items:[],
      album_gallery:[],
      bg_color:['bg-blue','bg-indigo','bg-purple','bg-pink','bg-red','bg-orange','bg-yellow','bg-green','bg-teal','bg-cyan','bg-gray'],
      currentPage:1,
      perPage:8,
      totalPicture:0,
      urlFile:process.env.VUE_APP_URL_BACKEND,
      loading:false,
      selected_item:null,
      currentOffset:1,
      limit:10,
      total:0,
    }
  },
  watch:{
    currentPage:function () {
      this.getListPicture()
    }
  },
  methods:{
    selectItem(item){
      this.selected_item = item
      this.getListPicture()
    },
    getData(){
      let payload = {
        page:this.currentOffset,
        limit:this.limit
      }
      this.loading = true
      
      AxiosCall.Get(payload, urlApi.intranet.list_picture_album ).then(res=>{
        if(res.success){
          for (let i in res.atributes){
            let data = res.atributes[i]
            const random = this.random()
            if(i != 0 ){
              data.bg_color = this.bg_color[random] === res.atributes[i-1].bg_color ? this.bg_color[this.random()] : this.bg_color[random]
            }else {
              data.bg_color = this.bg_color[random]
            }

            data.initial = data.title.match(/\b(\w)/g).join('')

            if(this.selected_item == null && i == 0){
              this.selected_item = data
              this.getListPicture()
            }
            this.album_gallery.push(data)
          }
          this.currentOffset++
          this.total = res.total
        }
        this.loading = false
      }).catch(e=>{
        this.loading = false
        this.$root.$children[0].errorMessage(e.response.data.message)
      })
    },
     getListPicture(){
      this.items = []
      let payload = {
        id:this.selected_item.id,
        page:this.currentPage,
        limit:this.perPage
      }

      AxiosCall.Get(payload, urlApi.intranet.list_picture).then(async res=>{
        if(res.success){
          for (let data of res.atributes){
            data.size_file = (data.file_size/1024).toFixed(2)
            let ini = this
            let resolution = await  new Promise(function (resolve) {
              ini.getMeta(
                  ini.urlFile+data.file_path+"/"+data.photo,
                  function(width, height) {
                    resolve({width, height})
                  }
              );
            })

            data.resolution = resolution.width + "x" + resolution.height
            data.height = resolution.height
            this.items.push(data)
          }
          this.totalPicture = res.total
        }else{
          this.$parent.errorMessage(res.message)
        }
      }).catch(e=>{
        console.log(e)
        this.$parent.errorMessage(e.response.data.message)
      })
    },
    downloadFile(item){
      AxiosCall.DownloadFile(this.urlFile+item.photo, item.photo_origin)
    },
    getMeta(url, callback) {
      var img = new Image();
      img.src = url;
      img.onload = function() { callback(this.width, this.height); }
    },
    inputText(){
      let myDiv = document.getElementById('container');
      myDiv.scrollTop = 0
      this.loading = false
    },
    random(){
      let key = this.getRandomInt(0, 10);
      return key
    },
    getRandomInt(min, max) {
      // Create byte array and fill with 1 random number
      let byteArray = new Uint8Array(1);
      window.crypto.getRandomValues(byteArray);

      let range = max - min + 1;
      let max_range = 256;
      if (byteArray[0] >= Math.floor(max_range / range) * range)
        return this.getRandomInt(min, max);

      return min + (byteArray[0] % range);
    },
  },
  created() {
    this.getData()
  },
  mounted() {
    $(document).trigger('theme:init', this);
    let ini = this
    if (window.PerfectScrollbar && $('.perfect-scrollbar').length > 0) {
      let ps
      $('.perfect-scrollbar:not(".aside-menu")').each(function () {
        if(this.id === 'container'){
          ps = new PerfectScrollbar(this, {
            suppressScrollX: true,
            wheelPropagation: false,
          })
          document.querySelector('#container').addEventListener('ps-y-reach-end', () => {
            setTimeout(()=>{
              if(!ini.loading) {
                  ini.getData()
              }
              setTimeout(()=>{
                ps.update()
              }, 10)
            }, 20)



          });
        }
      })
    }
  }
}
</script>

<style scoped>
.img-fluid, .img-thumbnail {
  max-width: 100% !important;
  max-height: 25vh !important;
  min-height:25vh !important;
}

.figure-img {
  text-align: center;
}

.card-figure .figure {
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
  max-height: 25vh;
}
</style>